import React, { SetStateAction } from 'react'
import { useIntl } from 'react-intl'
import { css } from '@emotion/css'
import {
  IconFilter,
  IconCaretLeft,
  IconCaretRight,
  IconSize,
  IconProps
} from '@contrast-security-inc/design-system-foundations'
import { Link, Text } from '@contrast-security-inc/design-system-typography'
import { getFilterCountTotal } from './state/utils'
import { FilterDefinition, FiltersValues } from '../../../types'

const iconProps = {
  color: 'turquoise90' as IconProps['color'],
  size: 'md' as IconSize
}
const filtersToggleCss = css`
  display: flex;
  align-items: center;
`
export const FiltersToggle = ({
  isOpen,
  setIsOpen,
  filterDefs,
  filters
}: {
  isOpen: boolean
  setIsOpen: React.Dispatch<SetStateAction<boolean>>
  // pass filterDefs & filters props to enable filter count
  // this should become required for consistency once established
  filterDefs?: FilterDefinition[]
  filters?: FiltersValues
}) => {
  const intl = useIntl()
  const onClick = React.useCallback(() => setIsOpen(!isOpen), [isOpen, setIsOpen])
  const IconCaret = isOpen ? IconCaretLeft : IconCaretRight
  const filterCount = getFilterCountTotal({ filterDefs, filters })

  return (
    <Link onClick={onClick} data-testid="filters-toggle">
      <div className={filtersToggleCss}>
        <IconCaret {...iconProps} />
        <Text font="bodyStrong">
          {intl.formatMessage({ id: 'title_toggleFilters' }, { isOpen })}
        </Text>
        <IconFilter {...iconProps} />
      </div>
      {filterCount > 0 && (
        <Text color="turquoise90" font="bodyStrong" data-testid="filters-toggle-applied-indicator">
          ({filterCount})
        </Text>
      )}
    </Link>
  )
}
